import controller from './pre-register-modal-controller';
import template from './pre-register-modal.html';

const preRegisterModalComponent = {
    bindings: {
        modalInstance: '<',
        resolve: '<'
    },
    controller,
    template
};

export default preRegisterModalComponent;



// WEBPACK FOOTER //
// ./app/components/user-admin/pre-register-modal/pre-register-modal-component.js